import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Configuration } from 'src/app/models/configurations/configuration';
import { ConfigurationState, CONFIGURATION_STATE_DATE_FIELDS } from 'src/app/models/configurations/configuration-state';
import { convertDates } from 'src/app/services/util/utils';
import { FabricService } from '../fabric/fabric.service';

const SERVICE_NAME = 'configurations-resources';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationsService {

  constructor(private fabricService: FabricService) {
  }

  getConfigurations(blueprintId: string): Observable<Configuration[]> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_configurations', {blueprintId});
  }

  applyConfiguration(configurationId: string, instanceId: string, skipTest: boolean): Observable<void> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'post_configurations_id_apply',
    {id: configurationId, instanceId, skipTest});
  }

  verifyConfiguration(configurationId: string, instanceId: string): Observable<void> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'post_configurations_id_verify', {id: configurationId, instanceId});
  }

  getConfigurationStates(instanceId: string): Observable<ConfigurationState[]> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_configurations_state_instanceid', {instanceId})
    .pipe(map(configurationStates => {
      configurationStates.forEach(configurationState => {
        convertDates(configurationState, CONFIGURATION_STATE_DATE_FIELDS);
      });
      return configurationStates;
    }));
  }

  getLatestConfigurationState(instanceId: string): Observable<ConfigurationState> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_configurations_state_instanceid_latest', {instanceId});
  }
}
